export default __webpack_public_path__ + "static/media/gem_purple.33b2e6ee.png";